// extracted by mini-css-extract-plugin
export default {"common":"common--iiHcoaLNN0BnHtk"};